import { useState, type ReactNode } from 'react';
import AppHeader from '../AppHeader';
import ViewAsBanner from '../ViewAsBanner';
import { Drawer, DrawerContent } from '../ui/drawer';
import AppSidebar from './AppSidebar';
import { useSidebarCollapsed } from './use-sidebar-collapsed';
import { cn } from '../../lib/utils';

const PAGE_ROOT = 'min-h-[100dvh] bg-background';
const PAGE_INSET = 'w-full px-4 py-4';

export default function AppLayout({ children }: { children: ReactNode }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, toggleCollapsed] = useSidebarCollapsed();

  return (
    <div className={PAGE_ROOT}>
      <div className="flex h-[100dvh]">
        <aside
          className={cn(
            'brand-rail sticky top-0 hidden h-[100dvh] shrink-0 flex-col transition-[width] duration-200 md:flex',
            collapsed ? 'w-14' : 'w-56',
          )}
        >
          <AppSidebar collapsed={collapsed} onToggleCollapse={toggleCollapsed} />
        </aside>
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <ViewAsBanner />
          <AppHeader onOpenMobileNav={() => setMobileOpen(true)} />
          <div className="min-h-0 flex-1 overflow-auto">
            <main className={`${PAGE_INSET} flex min-h-full flex-col`}>
              {children}
            </main>
          </div>
        </div>
      </div>
      <Drawer
        open={mobileOpen}
        swipeDirection="left"
        onOpenChange={setMobileOpen}
      >
        <DrawerContent className="nav-drawer">
          <AppSidebar onNavigate={() => setMobileOpen(false)} />
        </DrawerContent>
      </Drawer>
    </div>
  );
}
